<template>
  <div class="coreFunction">
    <div>
      <img src="./corefuntion1.png" alt="" class="width100">
    </div>
    <div class="container">
      <div class="row fun1">
        <indexHomeTit :desc="descList[0].desc"></indexHomeTit>
        <div class="col-xs-12 col-sm-12 col-md-4">
          <div class="imgP">
            <img src="./corefuntion2.png" alt="" class="width80">
          </div>
          <div class="mes">
            <p>
              <span class="marginRig10">预约就诊 </span><span>专家介绍</span>
            </p>
            <p>
              <span class="marginRig10">导医就诊</span> <span>现场取号</span>
            </p>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-4">
          <div class="imgP">
            <img src="./corefuntion3.png" alt="" class="width80">
          </div>
          <div class="mes">
            <p>

              <span class="marginRig10">店铺管理 </span><span>医生管理</span>
            </p>
            <p>
              <span class="marginRig10">病例管理</span> <span>财务管理</span>
            </p>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-4">
          <div class="imgP">
            <img src="./corefuntion4.png" alt="" class="width80">
          </div>
          <div class="mes">
            <p>
              <span class="marginRig10">店铺流水 </span><span>医生流水</span>
            </p>
            <p>

              <span class="marginRig10">就医统计</span> <span>售药统计</span>
            </p>
          </div>
          <a href="tel:18500058818" class="sysBtn minSysBtn">点击咨询</a>
        </div>
      </div>
    </div>
    <div class="fun2">
      <div class="container">
        <indexHomeTit :desc="descList[1].desc"></indexHomeTit>
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-3">
            <div class="fun2Mes">
              <p class="tit">自助服务端</p>
              <div class="text-center">
                <img src="./corefuntion6.png" alt="设备前端" title="设备前端" class="width100">
              </div>
              <div class="sign">
                <div class="signCon">
                  <p>身份识别，现场挂号，预约挂号</p>
                  <p>推荐医生，理疗预约,复诊</p>
                  <p>地图找医，病理找医，小票打印</p>
                  <p>挂号、抓药优惠券</p>
                  <p>微信、支付宝支付</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-3">
            <div class="fun2Mes">
              <p class="tit">药房/医生端</p>
              <div class="text-center">
                <img src="./corefuntion7.png" alt="设备前端" title="设备前端" class="width100">
              </div>
              <div class="sign">
                <div class="signCon">
                  <p>处方信息、抓药信息</p>
                  <p>电子开方、开方模板</p>
                  <p>划价结算</p>
                  <p>挂号人数查看</p>
                  <p>排队叫号</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-3">
            <div class="fun2Mes">
              <p class="tit">系统管理端</p>
              <div class="text-center">
                <img src="./corefuntion8.png" alt="设备前端" title="设备前端" class="width100">
              </div>
              <div class="sign">
                <div class="signCon">
                  <p>门诊管理，医生排班，合作治疗</p>
                  <p>门诊统计，客户统计，抓药数据</p>
                  <p>优惠券设置，快速通道，收银台</p>
                  <p>就诊费用统计</p>
                  <p>预约来源统计</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-3">
            <div class="fun2Mes">
              <p class="tit">手机应用端</p>
              <div class="text-center">
                <img src="./corefuntion9.png" alt="设备前端" title="设备前端" class="width100">
              </div>
              <div class="sign">
                <div class="signCon">
                  <p>随时随地就诊预约</p>
                  <p>就诊诊所选择</p>
                  <p>就诊历史、电子病历</p>
                  <p>微信支付、消息提醒</p>
                  <p>公众号信息推送</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="fun3">
      <div class="container">
        <indexHomeTit :desc="descList[2].desc"></indexHomeTit>
        <div class="row flex align-items fun3Box">
          <div class="col-xs-12 col-sm-12 col-md-6">
            <img src="./corefuntion10.jpg" alt="" class="width70">
            <p></p>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-6">
            <img src="./corefuntion11.png" alt="" class="width100">
          </div>
        </div>
      </div>
    </div>
    <div class="fun4">
      <div class="container">
        <indexHomeTit :desc="descList[3].desc"></indexHomeTit>
        <div class="row flex align-items-end fun3Box">
          <div class="col-xs-12 col-sm-12 col-md-12">
            <table class="table table-bordered funTable">
              <tr>
                <td rowspan="11" class="tit">预约挂号</td>
                <td class="f24">医生介绍</td>
                <td>医生的照片、资历、专长、擅长</td>
              </tr>
              <tr>

                <td>线上预约</td>
                <td>线上进行预约、支付、评价，可对接外部接口</td>
              </tr>
              <tr>

                <td>选择门诊挂号</td>
                <td>按距离选择门诊预约</td>
              </tr>
              <tr>

                <td>选择医生预约</td>
                <td>选择所需医生，可按时间进行预约</td>
              </tr>
              <tr>

                <td>选择病理预约</td>
                <td>根据自身病理进行挂号</td>
              </tr>
              <tr>

                <td>评价</td>
                <td>对医生诊疗的评价，门店环境评价，服务态度评价</td>
              </tr>
              <tr>

                <td>就医历史</td>
                <td>患者查看就医历史，可选择复诊医生</td>
              </tr>
              <tr>

                <td>理疗</td>
                <td>查看理疗次数，预约选择</td>
              </tr>
              <tr>

                <td>信息发布</td>
                <td>优惠政策，消息通知等实时发布便于查看</td>
              </tr>
              <tr>

                <td>预约凭证打印</td>
                <td>打印预约号、排队号、分诊室、叫号</td>
              </tr>
              <tr>

                <td>费用支付</td>
                <td>微信、支付宝，现金支付、退款</td>
              </tr>
            </table>
            <table class="table table-bordered funTable">
              <tr>
                <td rowspan="10" class="tit">数据统计</td>
                <td class="f24">患者统计</td>
                <td>患者个人信息、预约的来源、所选择就医地区</td>
              </tr>
              <tr>
                <td>病历统计</td>
                <td>就医列表，通过就医历史，快速预约复诊挂号</td>
              </tr>
              <tr>
                <td>就医评价</td>
                <td>统计就医信息评价</td>
              </tr>
              <tr>
                <td>病理统计</td>
                <td>统计优先病理，针对性做营销</td>
              </tr>
              <tr>
                <td>诊疗统计</td>
                <td>医生评价与所看病理统计</td>
              </tr>
              <tr>
                <td>预约统计</td>
                <td>可查询门诊、医生、初复诊、出勤、预约人数</td>
              </tr>
              <tr>
                <td>来源统计</td>
                <td>统计患者来源于那种形式</td>
              </tr>
              <tr>
                <td>外方统计</td>
                <td>统计外方医生，合作医生等信息</td>
              </tr>
              <tr>
                <td>经济统计</td>
                <td>工资 提成 比例分配等信息统计与核算</td>
              </tr>
              <tr>
                <td>流水统计</td>
                <td>店面、总流水时效更新、薪资明细、预收与实收分割</td>
              </tr>

            </table>
            <table class="table table-bordered funTable">
              <tr>
                <td rowspan="8" class="tit">运营推广</td>
                <td class="f24">设备广告</td>
                <td>针对于不同的门诊，设备屏保广告，自动播放图片+宣传广告，
                  医生简介、门诊信息的宣传</td>
              </tr>
              <tr>
                <td>优惠券</td>
                <td>电子优惠券的发放与管理</td>
              </tr>
              <tr>
                <td>绑定精准会员</td>
                <td>输入身份证号+手机短信认证，绑定身份证和微信关系</td>
              </tr>
              <tr>
                <td>消息提醒</td>
                <td>
                  <p>1、预约就医提醒 2、医生变更提醒</p>
                  <p>3、消息提醒，医生就诊，新闻消息</p>
                  </td>
              </tr>
              <tr>
                <td>信息接口服务</td>
                <td>预留接口 对接第三方服务平台，集成管理</td>
              </tr>
              <tr>
                <td>药房远程约诊医师</td>
                <td>通过推荐，患者可以在药房的设备端预约医生，进行
                  药房与门诊之间的引流</td>
              </tr>
              <tr>
                <td>约诊服务</td>
                <td>患者提前预约专家医师，集一定数量后，医师可到访门诊会诊</td>
              </tr>
              <tr>
                <td>医生推荐</td>
                <td>设备推荐、短信推荐 ，公众号推荐</td>
              </tr>
            </table>
            <table class="table table-bordered funTable">
              <tr>
                <td rowspan="7" class="tit">管理系统</td>
                <td class="f24">预约管理</td>
                <td>统一管理推荐的医生、挂号费、医生就诊时间，就诊地点</td>
              </tr>
              <tr>
                <td>门诊管理</td>
                <td>管理整体企业门店信息，管理门诊的地图信息</td>
              </tr>
              <tr>
                <td>医生管理</td>
                <td>
                  <p>1、管理各门诊的医生信息，专长，就医案例，视频，就诊时间（当医生
                    更改就诊时间，动态通知给已经预约的患者）</p>
                  <p>2、进行医生推荐管理、挂号价格管理</p></td>
              </tr>
              <tr>
                <td>权限管理</td>
                <td>设置各门诊的管理人员，配置各种角色权限：
                  管理人员，医生角色，统计角色，收银员、区域经理</td>
              </tr>
              <tr>
                <td>用户管理</td>
                <td>管理每个门店注册过来的用户信息，用户的头像，姓名，性别等信息</td>
              </tr>
              <tr>
                <td>设备管理</td>
                <td>设备管理，各门店设备管理，设置设备关联到门诊，便于后期对门店的
                  统计，配备遥控器，远程控制住开关机</td>
              </tr>
              <tr>
                <td>优惠券管理</td>
                <td>
                  <p>1：配置医生挂号的费用，针对整体活动或单个医生。</p>
                  <p>2：设置评价和是否抓药的优惠券</p>
                </td>
              </tr>

            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
  import indexHomeTit from '../indexhometit/indexhometit.vue';
  export default {
    components: {
      indexHomeTit
    },
    data() {
      return {
       descList: [
          {'desc': '完整的管理体系'},
          {'desc': '全终端管理系统'},
          {'desc': '精准的数据统计'},
          {'desc': '功能列表'}
        ]
      }
    }
  };
</script>

<style lang="stylus" rel="stylesheet/stylus">
.coreFunction
  .width80
    width 80%
  .indexHomeTit
    background-size 400px
  .fun1
    padding-top 30px
    .sysBtn
      display none
    .imgP
      padding:0 50px
      text-align center
    .mes
      padding:70px 0
      text-align center
      font-size 24px
      color:#6b7071
  .fun2
    background:  url(./corefuntion13.png) center no-repeat
    padding:50px 0
    .fun2Mes
      position: relative
      height 580px
      padding-top: 10px;
      background: rgba(255, 255, 255, 0.3)
      box-shadow: 0px 1px 13px #999;
      .tit
        width:235px
        padding 20px 0
        margin:0 auto
        background: url(./corefuntion12.png) center no-repeat
        background-size: cover;
        font-size 30px
        text-align center
        color #8f000b
      .sign
        height: 40%;
        width 100%
        position: absolute
        bottom 0
        left:0
        overflow: hidden;
        font-size 16px
        background:  url(./corefuntion5.png) center no-repeat
        background-size 100% 100%
        padding:18% 0 0 5%
        color #ffffff
  .fun3
    padding:90px 0 30px
    .width70
      width:90%
  .fun3Box
    padding:60px 0 0
    .col-md-6
      padding:0 75px
  .fun4
    padding:50px 0 0
    background:  url(./corefuntion14.jpg) center no-repeat
    background-size 100% 100%
    .funTable
      font-size 18px
      td
        border: 2px solid #ae4e4e;
        text-align left
        vertical-align middle
        padding:5px 0 5px 15px
        &:first-child
          width: 20%
          font-weight bold
          text-align center
      .f24
        width: 20%
        font-weight bold
        text-align center
      .tit
        width: 18%;
        font-size 30px;
        color:#a4272c
        vertical-align middle
        text-align center


@media (min-width: 320px) and (max-width: 750px)
    .coreFunction
      .width80
        width 80%
      .indexHomeTit
        background-size: 100%;
      .fun2
        .col-xs-12
          margin-bottom 20px
        .fun2Mes
          height: 530px;
          background: #fbfaf5;
          padding: 10px 0 0;
          .tit
            padding:20px 0
            font-size 22px
            background-size 100% 100%
          .sign
            height:35%
            .signCon
              position: absolute
              transform translate(0,-50%);
              left:20px
              top: 60%;
      .fun3
        padding: 20px 0 0;
        .fun3Box
          display block
          padding: 0 0;
      .fun1
        .mes
          padding: 36px 0;
        .sysBtn
          width: 100%;
          display block
          padding: 7px 25px;
          font-size: 16px;
          background: #c50000
          border-radius 5px
          text-align: center;
          color:#fff
          margin 10px 0 20px
      .fun4
        padding-top 50px
        margin-top: 50px;
        .fun3Box
          padding: 0 0;
        .funTable
          font-size 14px
          td
            &:first-child
              width: 11%;
              font-size 16px
              padding-left: 0;
          .f24
            font-size 16px
            padding-left: 0;
          .tit
            font-size 18px;

</style>



// WEBPACK FOOTER //
// src/components/corefuntion/corefuntion.vue